import React from "react";
import styles from "../css/styles.module.css";
import { NavLink } from "react-router-dom";
import Profile from "./profile.js";
import dashboard from "../images/dashboard.png";
import customer from "../images/customer.png";
import contact from "../images/contact.png";
import password from "../images/password.png";
import user from "../images/user.png";

export default function navbar(props) {
  return (
    <div className={styles.nav}>
      <Profile user={props.user}/>
      <ul>
        <li>
          <NavLink to="/" exact activeClassName={styles.activeLink}>
            <img src={dashboard} alt="icon" />
            <p>Dashboard</p>
          </NavLink>
        </li>
        <li>
          <NavLink to="/customer" exact activeClassName={styles.activeLink}>
            <img src={customer} alt="icon" />
            <p>Customer</p>
          </NavLink>
        </li>
        <li>
          <NavLink to="/contact" exact activeClassName={styles.activeLink}>
            <img src={contact} alt="icon" />
            <p>Contact</p>
          </NavLink>
        </li>
        <li>
          <NavLink to="/password" exact activeClassName={styles.activeLink}>
            <img src={password} alt="icon" />
            <p>Password</p>
          </NavLink>
        </li>
        {props.user.isAdmin && (
          <li>
            <NavLink to="/user" exact activeClassName={styles.activeLink}>
              <img src={user} alt="icon" />
              <p>User</p>
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
}
